import {ProjectDescriptorUse} from "./api/enums";
import {DataSource} from "typeorm";
import {fetchAuthSession} from "aws-amplify/auth";
import {Project} from "./api/db/entities/Project";

import {environment} from "../environments/environment";

import {PlatformUser} from "./api/db/entities/PlatformUser";
import {WriterProfile} from "./api/db/entities/WriterProfile";
import {BetaReaderProject} from "./api/db/entities/BetaReaderProject";
import {BetaReaderProfile} from "./api/db/entities/BetaReaderProfile";
import {ProjectProfileSelection} from "./api/db/entities/ProjectProfileSelection";
import { AwardedBadges } from "./api/db/entities/AwardedBadges";
import {Content} from "./api/db/entities/Content";
import {ProjectDescriptorCategory, ProjectDescriptorCategoryVariant} from "./api/project_schemas";
import {ProjectProfileGroup} from "./api/db/entities/ProjectProfileGroup";
import { ProjectMatchType } from "./api/db/entities/ProjectMatchType";

export function getVariant(c: ProjectDescriptorCategory, use: ProjectDescriptorUse): ProjectDescriptorCategoryVariant {
    if (!use) {
        return c.variants[0];
    }
    for (const variant of c.variants) {
        if (variant.uses.includes(use)) {
            return variant;
        }
    }
    return c.variants[0];
}

export class ORM {
    private static dataSource: DataSource;

    public static async getORMDatasource(): Promise<DataSource> {
        //Initialize a connection for this user if it doesn't exist.
        if (!this.dataSource?.isInitialized) {
            let apiKey: string;
            let session = await fetchAuthSession();
            try {
                apiKey = session.tokens.idToken.toString();
            } catch (error) {
                console.error("Failed to retrieve ID token from session: not logged in?", error);
                return null;
            }

            this.dataSource = new DataSource({
                type: "rng-remote-postgres",
                user: apiKey,
                remoteURL: environment.RNGRemoteLambda,
                remoteCacheURL: environment.RNGLambdaCache,
                logging: environment.dbLogging,
                cache: {
                    type: 'RNG',
                    ignoreErrors: true
                },
                entities: [
                    Project,
                    PlatformUser,
                    WriterProfile,
                    BetaReaderProject,
                    BetaReaderProfile,
                    ProjectProfileGroup,
                    ProjectProfileSelection,
                    Content,
                    AwardedBadges,
                    ProjectMatchType
                ]
            });
            await this.dataSource.initialize();
            console.log("Data Source has been initialized!", this.dataSource);
        }
        return this.dataSource;
    }
}
